module.exports = __webpack_public_path__ + "img/sec1_8.a88be92b.png";